'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.Statuses = void 0;
(function(Statuses) {
    Statuses["Completed"] = 'completed';
    Statuses["InProgress"] = 'in-progress';
    Statuses["NotStarted"] = 'not-started';
})(exports.Statuses || (exports.Statuses = {}));
exports.DefaultStatusLabels = void 0;
(function(DefaultStatusLabels) {
    DefaultStatusLabels["Completed"] = 'Status: Completed';
    DefaultStatusLabels["InProgress"] = 'Status: In Progress';
    DefaultStatusLabels["NotStarted"] = 'Status: Not Started';
})(exports.DefaultStatusLabels || (exports.DefaultStatusLabels = {}));
//# sourceMappingURL=status.js.map
